import { render, staticRenderFns } from "./specialoffer.vue?vue&type=template&id=3421f595&scoped=true&"
import script from "./specialoffer.vue?vue&type=script&lang=js&"
export * from "./specialoffer.vue?vue&type=script&lang=js&"
import style0 from "./specialoffer.vue?vue&type=style&index=0&id=3421f595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421f595",
  null
  
)

export default component.exports